import React from "react";
import Overview from "../../../components/pages/commercial/overview/Overview";
import RoleList from "../../../components/pages/commercial/SiteManagement/Role/RoleList";
import RoleForm from "../../../components/pages/commercial/SiteManagement/Role/RoleForm";
import SiteList from "../../../components/pages/commercial/SiteManagement/Site/SiteList";
import SiteForm from "../../../components/pages/commercial/SiteManagement/Site/SiteForm";
import WingList from "../../../components/pages/commercial/SiteManagement/Wing/WingList";
import WingForm from "../../../components/pages/commercial/SiteManagement/Wing/WingForm";
import FloorList from "../../../components/pages/commercial/SiteManagement/Floor/FloorList";
import FloorForm from "../../../components/pages/commercial/SiteManagement/Floor/FloorForm";
import UnitList from "../../../components/pages/commercial/SiteManagement/Unit/UnitList";
import UnitForm from "../../../components/pages/commercial/SiteManagement/Unit/UnitForm";
import SiteHierarchyBuilder from "../../../components/pages/commercial/SiteManagement/SiteHierarchyBuilder";
import SiteSetupWizard from "../../../components/pages/commercial/SiteManagement/SiteSetupWizard";
import MenuList from "../../../components/pages/commercial/SiteManagement/Menu/MenuList";
import MenuForm from "../../../components/pages/commercial/SiteManagement/Menu/MenuForm";
import ManageUsers from "../../../components/pages/commercial/UserManagment/ManageUsers";
import UserManagementForm from "../../../components/pages/commercial/UserManagment/UserManagementForm";
import TenantTenancyStepper from "../../../components/pages/commercial/UserManagment/TenancyStepper/TenantTenancyStepper";
import MyProfile from "../../../components/pages/Profile/MyProfile";
import VisitorRequest from "../../../components/pages/commercial/VisitorsManagment/InviteVisitor/VisitorRequest";
import InviteGuestForm from "../../../components/pages/commercial/VisitorsManagment/InviteVisitor/InviteGuestForm";
import WalkInVisitorList from "../../../components/pages/commercial/VisitorsManagment/walkinVisitor/WalkInVisitorList";
import GenerateQRCode from "../../../components/pages/commercial/VisitorsManagment/QRCode/GenerateQRCode";
import VisitorReports from "../../../components/pages/commercial/VisitorsManagment/Reports/VisitorReports";
import ParkingOperations from "../../../components/pages/commercial/ParkingManagement/ParkingOperations";
import VehicleRegistry from "../../../components/pages/commercial/ParkingManagement/vehicleregistry/VehicleRegistry";
import TenantFleetList from "../../../components/pages/commercial/ParkingManagement/vehicleregistry/TenantFleetList";
import PayAndPark from "../../../components/pages/commercial/ParkingManagement/payandpark/PayAndPark";
import AddVehicle from "../../../components/pages/commercial/ParkingManagement/vehicleregistry/AddVehicle";
import RentalParkingList from "../../../components/pages/commercial/ParkingManagement/rentalparking/RentalParkingList";
import OfferLease from "../../../components/pages/commercial/ParkingManagement/rentalparking/OfferLease";
import LeaseDetails from "../../../components/pages/commercial/ParkingManagement/rentalparking/LeaseDetails";
import AlertNotificationList from "../../../components/pages/commercial/AlertNotification/AlertNotificationList";
import AlertNotificationForm from "../../../components/pages/commercial/AlertNotification/AlertNotificationForm";
import MaintenanceModule from "../../../components/pages/commercial/Maintenance/MaintenanceModule";
import MaintenanceForm from "../../../components/pages/commercial/Maintenance/MaintenanceForm";
import VisitorPass from "../../../components/pages/commercial/VisitorsManagment/visitorpass/VisitorPass";
import AttendanceList from "../../../components/pages/commercial/UserManagment/Attendance/AttendanceList";
import AnnouncementList from "../../../components/pages/commercial/Announcement/AnnouncementList";
import AnnouncementForm from "../../../components/pages/commercial/Announcement/AnnouncementForm";
import ComplaintList from "../../../components/pages/commercial/ComplaintManagement/ComplaintList";
import ComplaintForm from "../../../components/pages/commercial/ComplaintManagement/ComplaintForm";
import ParkingTypeMasterList from "../../../components/pages/commercial/ParkingManagement/master/ParkingTypeMaster/ParkingTypeMasterList";
import ParkingTypeMasterForm from "../../../components/pages/commercial/ParkingManagement/master/ParkingTypeMaster/ParkingTypeMasterForm";

export const commercialRoutes = [
  // Commercial Module Routes - NOTE: Paths are now relative to the mount point (e.g., /zentcomm/)
  {
    path: "dashboard",
    element: <Overview />,
    breadcrumbs: ["Dashboard"],
  },
  {
    path: "my-profile",
    element: <MyProfile />,
    breadcrumbs: ["My Profile"],
  },
  {
    path: "user-management",
    element: <ManageUsers />,
    breadcrumbs: ["User Management"],
  },
  {
    path: "user-management/form",
    element: <UserManagementForm />,
    breadcrumbs: ["User Management", "User Form"],
  },
  {
    path: "user-management/manage-tenancy",
    element: <TenantTenancyStepper />,
    breadcrumbs: ["User Management", "Manage Tenancy"],
  },
  {
    path: "attendance",
    element: <AttendanceList />,
    breadcrumbs: ["Attendance"],
  },
  {
    path: "attendance-managemnet",
    element: <AttendanceList />,
    breadcrumbs: ["Attendance"],
  },
  {
    path: "announcement",
    element: <AnnouncementList />,
    breadcrumbs: ["Announcements"],
  },
  {
    path: "announcement/add",
    element: <AnnouncementForm />,
    breadcrumbs: ["Announcements", "Add"],
  },
  {
    path: "announcement/edit/:id",
    element: <AnnouncementForm />,
    breadcrumbs: ["Announcements", "Edit"],
  },
  {
    path: "visitor-managment/invited-visitor",
    element: <VisitorRequest />,
    breadcrumbs: ["Visitor Management", "Invited Visitor"],
  },
  {
    path: "visitor-managment/invited-visitor/add",
    element: <InviteGuestForm />,
    breadcrumbs: ["Visitor Management", "Invited Visitor", "Add"],
  },
  {
    path: "visitor-managment/visitor-pass",
    element: <VisitorPass />,
    breadcrumbs: ["Visitor Management", "Visitor Pass"],
  },
  {
    path: "visitor-managment/walk-in-visitor",
    element: <WalkInVisitorList />,
    breadcrumbs: ["Visitor Management", "Walk-In Visitor"],
  },
  {
    path: "visitor-managment/generateQR",
    element: <GenerateQRCode />,
    breadcrumbs: ["Visitor Management", "Generate QR Code"],
  },
  {
    path: "report/visitor",
    element: <VisitorReports />,
    breadcrumbs: ["Reports", "Visitor Report"],
  },
  {
    path: "parking-management/operations",
    element: <ParkingOperations />,
    breadcrumbs: ["Parking Management", "Parking Operations"],
  },
  {
    path: "parking-management/vehicle-registry",
    element: <VehicleRegistry />,
    breadcrumbs: ["Parking Management", "Vehicle Registry"],
  },
  {
    path: "parking-management/tenant-fleet",
    element: <TenantFleetList />,
  },
  {
    path: "parking-management/pay-and-park",
    element: <PayAndPark />,
    breadcrumbs: ["Parking Operations", "Pay & Park"],
  },
  {
    path: "parking-management/rental-parking",
    element: <RentalParkingList />,
    breadcrumbs: ["Parking Management", "Rental Parking"],
  },
  {
    path: "parking-management/rental-parking/offer",
    element: <OfferLease />,
    breadcrumbs: ["Parking Management", "Rental Parking", "Offer Lease"],
  },
  {
    path: "parking-management/rental-parking/:id",
    element: <LeaseDetails />,
    breadcrumbs: ["Parking Management", "Rental Parking", "Lease Details"],
  },
  {
    path: "parking-management/vehicle-registry/:tenantId",
    element: <TenantFleetList />,
    breadcrumbs: ["Parking Management", "Vehicle Registry", "Fleet Vehicles"],
  },
  {
    path: "parking-management/vehicle-registry/:tenantId/add",
    element: <AddVehicle />,
    breadcrumbs: ["Parking Management", "Vehicle Registry", "Fleet Vehicles", "Add Vehicle"],
  },
  {
    path: "site-management/site",
    element: <SiteList />,
    breadcrumbs: ["Site Management", "Site List"],
  },
  {
    path: "site-management/site/form",
    element: <SiteForm />,
    breadcrumbs: ["Site Management", "Site", "Form"],
  },
  {
    path: "site-management/builder",
    element: <SiteHierarchyBuilder />,
    breadcrumbs: ["Site Management", "Site Preview"],
  },
  {
    path: "site-management/setup-wizard",
    element: <SiteSetupWizard />,
    breadcrumbs: ["Site Management", "Setup Wizard"],
  },
  {
    path: "site-management/role",
    element: <RoleList />,
    breadcrumbs: ["Site Management", "Role List"],
  },
  {
    path: "site-management/role/form",
    element: <RoleForm />,
    breadcrumbs: ["Site Management", "Role", "Form"],
  },
  {
    path: "site-management/wing",
    element: <WingList />,
    breadcrumbs: ["Site Management", "Wing"],
  },
  {
    path: "site-management/wing/form",
    element: <WingForm />,
    breadcrumbs: ["Site Management", "Wing", "Form"],
  },
  {
    path: "site-management/floor",
    element: <FloorList />,
    breadcrumbs: ["Site Management", "Floor"],
  },
  {
    path: "site-management/floor/form",
    element: <FloorForm />,
    breadcrumbs: ["Site Management", "Floor", "Form"],
  },
  {
    path: "site-management/unit",
    element: <UnitList />,
    breadcrumbs: ["Site Management", "Unit"],
  },
  {
    path: "site-management/unit/form",
    element: <UnitForm />,
    breadcrumbs: ["Site Management", "Unit", "Form"],
  },
  {
    path: "site-management/menu",
    element: <MenuList />,
    breadcrumbs: ["Site Management", "Menu"],
  },
  {
    path: "site-management/menu/form",
    element: <MenuForm />,
    breadcrumbs: ["Site Management", "Menu", "Form"],
  },
  {
    path: "alert-notification",
    element: <AlertNotificationList />,
    breadcrumbs: ["Alert Notification", "List"],
  },
  {
    path: "alert-notification/add",
    element: <AlertNotificationForm />,
    breadcrumbs: ["Alert Notification", "Add Notification"],
  },
  {
    path: "alert-notification/edit/:id",
    element: <AlertNotificationForm />,
    breadcrumbs: ["Alert Notification", "Edit Notification"],
  },
  {
    path: "maintenance",
    element: <MaintenanceModule />,
    breadcrumbs: ["Maintenance"],
  },
  {
    path: "maintenance/add",
    element: <MaintenanceForm />,
    breadcrumbs: ["Maintenance", "Add Maintenance"],
  },
  {
    path: "complaint-management",
    element: <ComplaintList />,
    breadcrumbs: ["Complaints"],
  },
  {
    path: "complaint-management/add",
    element: <ComplaintForm />,
    breadcrumbs: ["Complaints", "Raise Complaint"],
  },
  {
    path: "complaint-management/edit/:id",
    element: <ComplaintForm />,
    breadcrumbs: ["Complaint Management", "Edit"],
  },
  {
    path: "parking-type-master",
    element: <ParkingTypeMasterList />,
    breadcrumbs: ["Parking Management", "Parking Type Master"],
  },
  {
    path: "parking-type-master/add",
    element: <ParkingTypeMasterForm />,
    breadcrumbs: ["Parking Management", "Parking Type Master", "Add"],
  },
  {
    path: "parking-type-master/edit/:id",
    element: <ParkingTypeMasterForm />,
    breadcrumbs: ["Parking Management", "Parking Type Master", "Edit"],
  },
];
